import FacebookF from '@pagerland/icons/src/line/FacebookF';
import Instagram from '@pagerland/icons/src/line/Instagram';
import Twitter from '@pagerland/icons/src/line/TwitterAlt';
import Linkedin from '@pagerland/icons/src/line/LinkedinAlt';
export const socialLinks= [
    {
      icon: FacebookF,
      href: 'https://www.facebook.com/sparklean.atlanta',
      title: 'Facebook',
    },
    {
      icon: Twitter,
      href: 'https://twitter.com/@sparkleanmaster',
      title: 'Twitter',
    },
    {
      icon: Instagram,
      href: 'https://instagram.com/sparkleanllcatl',
      title: 'Instagram',
    },
    {
      icon: Linkedin,
      href: 'https://myessl.com',
      title: 'Linkedin',
    },
  ]